const pxClassResource = {
  path: 'pxClassResource/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/pxClassResource'], resolve)
}
export default pxClassResource



// WEBPACK FOOTER //
// ./src/router/pages/student_user/pxClassResource/index.js